import { Component } from '@angular/core';
import { ILoadingCellRendererAngularComp } from '@ag-grid-community/angular';
import { ILoadingCellRendererParams } from '@ag-grid-community/core';
import { InputLoadingModule } from '../../input-loading/input-loading.module';

@Component({
  selector: 'rx-applications-custom-loading-overlay',
  template: `<rx-applications-input-loading></rx-applications-input-loading>`,
  standalone: true,
  imports: [InputLoadingModule],
})
export class CustomLoadingOverlayComponent implements ILoadingCellRendererAngularComp {
  params: ILoadingCellRendererParams;

  agInit(params: ILoadingCellRendererParams): void {
    this.params = params;
  }
}
